<template>
    <BaseChip
        class="gst-order-tm-status-chip"
        :class="{
            'gst-order-tm-status-chip--approved': isApproved,
            'gst-order-tm-status-chip--reversed': isReversed,
            'gst-order-tm-status-chip--pending': isPending,
        }">
        <span class="content">{{ name }}</span>
        <slot name="append-inner"></slot>
    </BaseChip>
</template>

<script>
import orderStatusConstants from '@utils/constants/orderStatus';
import BaseChip from './BaseChip.vue';

const orderTMStatus = orderStatusConstants.PARTNERS.TICKETMASTER;

export default {
    name: 'HotelPriceRuleStatusChip',
    components: {
        BaseChip,
    },
    props: {
        value: {
            type: String,
            required: true,
        },
    },
    computed: {
        item() {
            return orderTMStatus.ITEMS.find((item) => item.value === this.value);
        },
        isApproved() {
            return this.value === orderTMStatus.TYPES.APPROVED;
        },
        isReversed() {
            return this.value === orderTMStatus.TYPES.REVERSED;
        },
        isPending() {
            return this.value === orderTMStatus.TYPES.PENDING;
        },
        name() {
            return this.$t(this.item ? this.item.i18nKey : '');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@scssVariables';

.gst-order-tm-status-chip.gst-order-tm-status-chip--approved {
    background-color: rgba(theme-color-hex('statusSuccess'), 0.2);
}

.gst-order-tm-status-chip.gst-order-tm-status-chip--pending {
    background-color: rgba(theme-color-hex('warning'), 0.2);
}

.gst-order-tm-status-chip.gst-order-tm-status-chip--reversed {
    background-color: #fed2cb;
}
</style>
